import {useCallback} from 'react';
import {useSelector} from '@xstate/react';
import {usePlayerContext} from './usePlayerContext';
import {useSubtitleTrackService} from './useTrackContext';

/**
 * Handles setting the active audio track on the player;
 *
 * @returns (trackId: string) => void | a handler for setting the active audio track
 */
export const useSetActiveSubtitle = (): ((trackId: string | null) => void) => {
  const {player} = usePlayerContext();
  const activeTrack = useSelector(
    useSubtitleTrackService(),
    ({context}) => context.activeTrack
  );

  const setActiveSubtitle = useCallback(
    (trackId: string | null) => {
      if (!player) return;

      // First disable the currently active track.
      // This is because bitmovin supports having multiple tracks enabled
      // at once, but we don't want to support that currently.
      if (activeTrack) {
        player.subtitles.disable(activeTrack.id);
      }

      if (trackId !== null) {
        player.subtitles.enable(trackId, true);
      }
    },
    [activeTrack, player]
  );

  return setActiveSubtitle;
};
